import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';

import { from, lastValueFrom, take } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private auth = inject(Auth);

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return from(this.handle(request, next));
  }

  async handle(request: HttpRequest<any>, next: HttpHandler) {
    const user = await lastValueFrom(authState(this.auth).pipe(take(1)));
    if (!user) return await lastValueFrom(next.handle(request));

    const token = await user.getIdToken();
    const clone = request.clone({
      headers: request.headers.set('Authorization', `Bearer ${token}`)
    });
    return await lastValueFrom(next.handle(clone));
  }
}
